import React, { useState } from "react";
import { useFirestoreAdmin } from "../context/FirestoreAdminProvider";
import { COLLECTION_RELATIONSHIPS, fetchLinkedDocuments } from "../services/relationshipService";
import { fetchDocuments } from "../services/firestoreDataService";

export default function RelationshipViewerPage() {
  const { collectionName, selectCollection, allCollections } = useFirestoreAdmin();
  const [docId, setDocId] = useState("");
  const [docData, setDocData] = useState(null);
  const [links, setLinks] = useState([]);
  const [loading, setLoading] = useState(false);

  const graph = COLLECTION_RELATIONSHIPS;

  const loadDoc = async () => {
    if (!docId.trim()) return;
    setLoading(true);
    try {
      const result = await fetchDocuments({
        collectionName,
        docIdQuery: docId.trim(),
        pageLimit: 1,
      });
      const row = result.rows[0];
      if (!row) {
        setDocData(null);
        setLinks([]);
        return;
      }
      setDocData(row.data);
      setLinks(await fetchLinkedDocuments(collectionName, row.id, row.data));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-4">
      <header>
        <h1 className="text-2xl font-bold">Relationship Viewer</h1>
        <p className="text-sm text-slate-600">Explore linked documents across collections.</p>
      </header>
      <div className="fa-card p-4">
        <p className="mb-2 text-xs font-semibold uppercase text-slate-500">Known relationships</p>
        <div className="flex flex-wrap gap-2 text-xs">
          {graph.map((r, i) => (
            <span key={i} className="rounded bg-slate-100 px-2 py-1">{r.from} → {r.to}</span>
          ))}
        </div>
      </div>
      <div className="fa-card flex flex-wrap gap-2 p-4">
        <select className="rounded-lg border px-2 py-1.5 text-sm" value={collectionName} onChange={(e) => selectCollection(e.target.value)}>
          {allCollections.map((c) => <option key={c} value={c}>{c}</option>)}
        </select>
        <input className="rounded-lg border px-2 py-1.5 text-sm" placeholder="Document ID" value={docId} onChange={(e) => setDocId(e.target.value)} />
        <button type="button" className="fa-btn fa-btn-primary" onClick={loadDoc} disabled={loading}>Load links</button>
      </div>
      {docData && (
        <div className="fa-card p-4 text-sm">
          <p className="font-semibold">Document: {docId}</p>
          <pre className="mt-2 max-h-32 overflow-auto rounded bg-slate-50 p-2 text-xs">{JSON.stringify(docData, null, 2)}</pre>
        </div>
      )}
      {links.map((link) => (
        <div key={`${link.collection}-${link.value}`} className="fa-card p-4">
          <p className="font-semibold">{collectionName} → {link.collection}</p>
          <p className="text-xs text-slate-500">{link.field} = {String(link.value)}</p>
          {link.error && <p className="text-amber-700 text-xs">Query failed — index may be required</p>}
          <ul className="mt-2 space-y-1 font-mono text-xs">
            {link.documents.map((d) => (
              <li key={d.id}>{d.id}</li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
}
